<template>
  <v-form>
    <ComunDialogComp v-model="estadoComp" maxWidth="1200" @close-modal="CerrarModal">
      <template v-slot:body>
        <v-card>
          <v-stepper v-model="step" :editable="true">
            <v-stepper-header>
              <template v-for="n in steps">
                <v-stepper-step :key="n.n" :complete="step > n.n" :step="n.n" editable>
                  {{ n.name }}
                </v-stepper-step>
              </template>
            </v-stepper-header>

            <v-stepper-items>
              <!-- Paso 1: Crear año lectivo -->
              <v-stepper-content step="1">
                <div>
                  <v-form ref="formDatos" lazy-validation>
                    <v-card>
                      <v-card-title class="btn_otro">
                        Crear año lectivo
                      </v-card-title>

                      <v-divider></v-divider>

                      <v-card-text>
                        <v-row>
                          <v-col cols="12" sm="12" md="12" class="py-0">
                            <v-text-field label="Nombre" v-model="anoLectivoMultiStep.nom_anolectivo" type="text"
                              :rules="[rul.required, rul.max100]"></v-text-field>
                          </v-col>

                          <v-col cols="12" sm="6" md="6" class="py-0">
                            <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition"
                              offset-y max-width="290px" min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field v-model="computedDateFormattedAnioMultistep" label="Fecha de inicio"
                                  readonly v-on="on" :rules="[rul.required]"></v-text-field>
                              </template>

                              <v-date-picker v-model="anoLectivoMultiStep.fecha_inicio" no-title :min="nowDate"
                                @input="menu = false"></v-date-picker>
                            </v-menu>
                          </v-col>

                          <v-col cols="12" sm="6" md="6" class="py-0">
                            <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition"
                              offset-y max-width="290px" min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field v-model="computedDateFormattedAnioMultistep2" label="Fecha de cierre"
                                  readonly v-on="on" :rules="[rul.required]"></v-text-field>
                              </template>

                              <v-date-picker v-model="anoLectivoMultiStep.fecha_cierre" no-title
                                :min="anoLectivoMultiStep.fecha_inicio" @input="menu1 = false"></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-card-text>

                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <ButtonComp icon-but="fas fa-plus" @click="setValues()" textButton="BOTON AMBIENTE TEST" />

                        <ButtonComp icon-but="fas fa-plus" @click="crearAnioLectivoMultiStep()"
                          textButton="Crear año lectivo" />
                      </v-card-actions>
                    </v-card>
                  </v-form>
                </div>
              </v-stepper-content>

              <!-- Paso 2: Crear Periodo -->
              <v-stepper-content step="2">
                <div class="modal-content">
                  <v-form ref="formDatosPeriodo" lazy-validation>
                    <v-card>
                      <v-card-title class="btn_otro">
                        <v-row class="d-flex justify-space-between py-0">
                          <h3>
                            Crear períodos en
                            {{ anoLectivoMultiStep.nom_anolectivo }}
                          </h3>
                        </v-row>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" sm="12" md="6" class="py-0" style="padding-top: 20px !important">
                            <v-text-field label="Año lectivo" v-model="anoLectivoMultiStep.nom_anolectivo"
                              item-text="nom_anolectivo" item-value="id" readonly :disabled="true"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" class="mt-2">
                            <v-text-field label="Nombre" v-model="periodosMultiStep.nombre_periodo"
                              :rules="[rul.required, rul.max50]"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" class="py-0">
                            <v-select label="Niveles" v-model="periodosMultiStep.id_nivel" :items="Niveles"
                              return-object item-text="desc_nivel" multiple chips :rules="[rul.selectReq]"></v-select>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" class="py-0">
                            <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition"
                              offset-y max-width="290px" min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field v-model="periodosMultiStep.fecha_inicio" label="Fecha de inicio" readonly
                                  v-on="on" :rules="[rul.required]"></v-text-field>
                              </template>
                              <v-date-picker no-title v-model="periodosMultiStep.fecha_inicio"
                                :min="anoLectivoMultiStep.fecha_inicio" :max="fecha_cierre_anio_futuro"
                                @input="menu2 = false"></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" class="py-0">
                            <v-menu v-model="menu3" :close-on-content-click="false" transition="scale-transition"
                              offset-y max-width="290px" min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field v-model="periodosMultiStep.fecha_cierre" label="Fecha de cierre" readonly
                                  v-on="on" :rules="[rul.required]"></v-text-field>
                              </template>
                              <v-date-picker no-title v-model="periodosMultiStep.fecha_cierre"
                                :min="anoLectivoMultiStep.fecha_inicio" :max="fecha_cierre_anio_futuro"
                                @input="menu3 = false"></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <ButtonComp icon-but="fas fa-plus" textButton="Crear periodo" @click="addPeriodosFuture" />
                        <ButtonComp textButton="Siguiente" @click="step = '3'" />
                      </v-card-actions>
                    </v-card>
                  </v-form>
                </div>
              </v-stepper-content>

              <!-- Paso 3: Visualizar Periodos -->
              <v-stepper-content step="3">
                <div class="modal-content">
                  <v-card>
                    <v-card-title class="btn_otro">
                      <v-row class="d-flex justify-space-between py-0">
                        <h3>
                          Periodos del {{ anoLectivoMultiStep.nom_anolectivo }}
                        </h3>
                      </v-row>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-data-table :headers="headersFuture" :items="anoLectivoMultiStep.periodos"
                      :sort-by="['fecha_inicio']" :sort-desc="[true]" class="elevation-1 black--text" fixed-header>
                      <template v-slot:[`item.fecha_inicio`]="{ item }">
                        {{ item.fecha_inicio | filtroFecha }}
                      </template>
                      <template v-slot:[`item.fecha_cierre`]="{ item }">
                        {{ item.fecha_cierre | filtroFecha }}
                      </template>
                      <template v-slot:[`item.status`]="{ item }">
                        <v-chip v-if="
                          item.fecha_inicio <= nowDate &&
                          item.fecha_cierre < nowDate
                        " small class="color_inactivo">
                          Cerrado
                        </v-chip>
                        <v-chip v-else-if="
                          item.fecha_inicio <= nowDate &&
                          item.fecha_cierre >= nowDate
                        " small class="color_activo">
                          Activo
                        </v-chip>
                        <v-chip v-else-if="
                          item.fecha_inicio >= nowDate &&
                          item.fecha_cierre >= nowDate
                        ">
                          Sin Iniciar
                        </v-chip>
                      </template>

                      <template v-slot:[`item.action_eliminar`]="{ item }">
                        <v-btn class="mx-2 btn_eliminar" fab x-small @click="elimnarPeriodo(item)">
                          <v-icon>fa-trash</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <ButtonComp textButton="Atrás" @click="step = 2" />
                      <ButtonComp textButton="Siguiente" @click="step = 4" />
                    </v-card-actions>
                  </v-card>
                </div>
              </v-stepper-content>

              <!-- Paso 4: Escoger año lectivo a importar -->
              <v-stepper-content step="4">
                <div>
                  <v-card>
                    <v-card-title class="btn_otro">
                      <v-row class="d-flex justify-space-between py-0">
                        <h3>
                          Escoja la estructura de súbmodulos del año lectivo que
                          va replicar.
                        </h3>
                      </v-row>
                    </v-card-title>

                    <v-col cols="12" sm="12" md="6" class="py-0" style="padding-top: 20px !important">
                      <v-select label="Año lectivo" v-model="id_ano_lectivo_replicar" :items="anos_activos"
                        item-text="nom_anolectivo" :rules="[rul.selectReq]" item-value="id">
                      </v-select>
                    </v-col>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <!-- <ButtonComp textButton="next" @click="step = 5" /> -->
                      <ButtonComp textButton="Atrás" @click="step = 3" />
                      <ButtonComp textButton="Importar configuracion del año lectivo pasado"
                        @click="cierreFinal(id_ano_lectivo_replicar, false)" />
                    </v-card-actions>
                  </v-card>
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card>

        <v-dialog max-width="1200" v-model="openResult" persistent>
          <v-card>
            <v-toolbar color="primary" dark>
              <v-icon left>mdi-eye</v-icon>
              <v-toolbar-title>Previsualización del cierre de año (Reporte
                alumnos)</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="dialogConfi = true"><v-icon left>mdi-check</v-icon>Confirmar cierre</v-btn>
            </v-toolbar>

            <v-card-text class="pa-6">
              <p>Clickea o selecciona un grado :</p>

              <v-chip-group show-arrows class="pb-4"
                active-class="yellow darken-3 white--text animate__animated animate__pulse animate__infinite">
                <v-chip filter-icon filter class="blue darken-3 white--text" v-for="grado in gradosButtons"
                  :key="grado.id_grado_adm" @click="ShowDetalleAlumnoGrados(grado)">{{ grado.desc_grado }}</v-chip>
              </v-chip-group>

              <v-expansion-panels v-model="panelAlumnosNotas" v-show="showDetalle" accordion focusable>
                <v-expansion-panel v-for="item in dataAlumnos" :key="item.id_alumno">
                  <v-expansion-panel-header class="px-2 pa-0">
                    <v-row no-gutters>
                      <v-col cols="4">
                        <v-avatar size="36px">
                          <img alt="Avatar"
                            src="https://static.vecteezy.com/system/resources/previews/038/042/984/non_2x/graduate-student-avatar-icon-in-colors-vector.jpg" />
                        </v-avatar>
                        <b>{{ item.nombres_completos }}</b>
                      </v-col>
                      <v-col cols="8" class="text--secondary customrow">
                        <v-fade-transition leave-absolute>
                          <v-row justify="space-around" no-gutters style="width: 100%">
                            <v-col cols="6">
                              Grado: {{ item.desc_grado }}
                            </v-col>
                            <v-col cols="auto">
                              Situacion final:
                              <v-chip class="text-uppercase" label :class="item.criterio_estado_final == 'PROMOVIDO'
                                ? 'color_aprobado'
                                : item.criterio_estado_final ==
                                  'PERMANENCIA'
                                  ? 'color_desaprobado'
                                  : item.criterio_estado_final ==
                                    'RECUPERACIÓN PEDAGÓGICA'
                                    ? 'color_recuperacion'
                                    : ''
                                " small>
                                {{ item.criterio_estado_final }}
                              </v-chip>
                            </v-col>
                          </v-row>
                        </v-fade-transition>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content class="expaco">
                    <small class="text-caption customheight">
                      DETALLES DE LAS AREAS EVALUADAS:
                    </small>

                    <v-data-table dense :items="item.areas_estudiante" item-value="name" class="elevation-1"
                      hide-default-header hide-default-footer>
                      <template v-slot:header>
                        <thead>
                          <tr style="background-color: #efefef">
                            <th rowspan="2" class="text-center">Area</th>
                            <th rowspan="2" class="text-center">
                              Cantidad Competencias del Área
                            </th>
                            <th rowspan="2" class="text-center">
                              50% de Competencias del Área
                            </th>
                            <th colspan="5" class="text-center">
                              Calificaciones del Estudiante
                            </th>
                            <th rowspan="2" class="text-center">
                              Cantidad Calificaciones "AD+A"
                            </th>
                            <th rowspan="2" class="text-center">
                              Cantidad Calificaciones "B"
                            </th>
                            <th rowspan="2" class="text-center">
                              Cantidad Calificaciones "C"
                            </th>
                            <th rowspan="2" class="text-center">
                              Condicion del Estudiante
                            </th>
                          </tr>
                          <tr style="background-color: #efefef">
                            <th class="text-center">C1</th>
                            <th class="text-center">C2</th>
                            <th class="text-center">C3</th>
                            <th class="text-center">C4</th>
                            <th class="text-center">C5</th>
                          </tr>
                        </thead>
                      </template>

                      <template v-slot:body="{ items }">
                        <tbody>
                          <tr v-for="areas in items" :key="areas.id_area_adm">
                            <td class="text-center">{{ areas.desc_area }}</td>
                            <td class="text-center">
                              {{ areas.nivel_logro_competencias_area.length }}
                            </td>
                            <td class="text-center">
                              {{
                                Math.round(
                                  areas.nivel_logro_competencias_area.length / 2
                                )
                              }}
                            </td>
                            <td v-for="index in 5" :key="index" class="text-center" :style="obtenerEstilosParaNotas(
                              obtenerNotaComp(
                                areas.nivel_logro_competencias_area,
                                index
                              )
                            )
                              ">
                              {{
                                convertirNumAliteral(
                                  obtenerNotaComp(
                                    areas.nivel_logro_competencias_area,
                                    index
                                  )
                                )
                              }}
                            </td>
                            <td class="text-center">
                              {{
                                conteoTipoNotasComp(
                                  areas.nivel_logro_competencias_area,
                                  "AD+A"
                                )
                              }}
                            </td>
                            <td class="text-center">
                              {{
                                conteoTipoNotasComp(
                                  areas.nivel_logro_competencias_area,
                                  "B"
                                )
                              }}
                            </td>
                            <td class="text-center">
                              {{
                                conteoTipoNotasComp(
                                  areas.nivel_logro_competencias_area,
                                  "C"
                                )
                              }}
                            </td>
                            <td class="text-center" style="width: 150px">
                              <b :style="{
                                color:
                                  areas.criterio_area_condicion == 'PROMOVIDO'
                                    ? '#4caf50'
                                    : areas.criterio_area_condicion ==
                                      'PERMANENCIA'
                                      ? '#e53935'
                                      : areas.criterio_area_condicion ==
                                        'RECUPERACIÓN PEDAGÓGICA'
                                        ? '#bd8d06'
                                        : '',
                              }">{{ areas.criterio_area_condicion }}</b>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-data-table>
                    <br />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <br />
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- MODAL DE CONFIRMACIÓN CIERRE DEL AÑO -->
        <ComunDialogComp v-model="dialogConfi" Confirmdialog @close-modal="dialogConfi = false" titleWindow="Confirmar"
          @confirm-item="cierreFinal(id_ano_lectivo_replicar, true)" @cancel-item="dialogConfi = false">
          <template v-slot:body>
            ¿Confirma el cierre del año absolutamente! Una vez confirmada la
            accion se reiniciará la sesión?
          </template>
        </ComunDialogComp>
      </template>
    </ComunDialogComp>
  </v-form>
</template>

<script>
import axios from "../../../helpers/axios";
import { mapActions, mapMutations } from "vuex";
import ComunDialogComp from "../../../components/ComponentsEst/ComunDialogComp.vue";
import ButtonComp from "../../../components/ComponentsEst/TableButtonComp.vue";

//TEST
// eslint-disable-next-line no-unused-vars
import respuesta from "../components/datatest";

export default {
  name: "CrearNuevoAnioModal",
  props: {
    estadoComp: Boolean,
  },
  components: {
    ComunDialogComp,
    ButtonComp,
  },
  data: () => ({
    dialogConfi: false,
    panelAlumnosNotas: [],
    showDetalle: false,
    gradosButtons: [],
    dataAlumnos: [],
    dataAlumnosOriginal: [],
    datoLogin: sessionStorage,
    step: 1,
    openResult: false,
    // step: 5,
    steps: [
      {
        name: "Crear año lectivo",
        n: 1,
      },
      {
        name: "Crear periodos",
        n: 2,
      },
      {
        name: "Visualizar periodos",
        n: 3,
      },
      {
        name: "Replicar configuración",
        n: 4,
      },
    ],
    /*______________
        │   * Paso 1     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    anoLectivoMultiStep: {
      nom_anolectivo: "",
      fecha_inicio: null,
      fecha_cierre: null,
      periodos: [],
    },
    periodosMultiStep: {
      nombre_periodo: "",
      fecha_inicio: null,
      fecha_cierre: null,
    },
    menu: false,
    menu1: false,
    nowDate: new Date(new Date().getFullYear(), 0, 1)
      .toISOString()
      .slice(0, 10), //ESTO LO VOY A REMPLAZAR
    /*_____________
        │   * Paso 2    │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    Niveles: [],
    menu2: false,
    menu3: false,
    fecha_cierre_anio_futuro: "",
    /*______________
        │   * Paso 3     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    headersFuture: [
      {
        text: "NOMBRE DEL PERIODO",
        value: "nombre_periodo",
        class: "secondary black--text",
      },
      {
        text: "FECHA DE INICIO",
        value: "fecha_inicio",
        class: "secondary black--text",
      },
      {
        text: "FECHA DE CIERRE",
        value: "fecha_cierre",
        class: "secondary black--text",
      },
      {
        text: "ESTADO",
        align: "center",
        value: "status",
        sortable: false,
        class: "secondary black--text",
      },
      {
        text: "ELIMINAR",
        value: "action_eliminar",
        sortable: false,
        align: "center",
        class: "secondary black--text px-0 mx-0",
        width: "1",
      },
    ],
    /*______________
        │   * Paso 4     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    anos_activos: [],
    id_ano_lectivo_replicar: -1,

    /*____________________________________
        │   * Validaciones del formulario     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    rul: {
      required: (value) => !!value || "Campo requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
    },
  }),
  computed: {
    computedDateFormattedAnioMultistep() {
      return this.formatDate(this.anoLectivoMultiStep.fecha_inicio);
    },

    computedDateFormattedAnioMultistep2() {
      return this.formatDate(this.anoLectivoMultiStep.fecha_cierre);
    },
  },
  mounted() {
    this.getAllNivelesAdmin();
    this.getAllAnoLectivosActivos();
    // this.cierreFinal(this.id_ano_lectivo_replicar, false)
  },
  methods: {
    ...mapActions({
      logout: "login/logout",
      verificarSession: "login/verificarSession",
      LogoUrl: "LogoUrl",
    }),
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    /*___________________________________________________________
        │   * Método para convertir nota numerica a nota literal     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    convertirNumAliteral(notaNum) {
      switch (notaNum) {
        case 4:
          return "AD";
        case 3:
          return "A";
        case 2:
          return "B";
        case 1:
          return "C";
        default:
          return "";
      }
    },
    /*_____________________________________________________________________
        │   * Método para obtener los estilos deacuerdo a la nota obtenido     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    obtenerEstilosParaNotas(notaNum) {
      switch (notaNum) {
        case 4:
          return "background-color:#4caf50; color: white; font-weight: bolder;";
        case 3:
          return "background-color:#4caf50; color: white; font-weight: bolder;";
        case 2:
          return "background-color:#ffbc00; color: white; font-weight: bolder;";
        case 1:
          return "background-color:#e53935; color: white; font-weight: bolder;";
        default:
          return "";
      }
    },
    /*________________________________________________________________
        │   * Método para obtener el valor o nota de las competencias     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    obtenerNotaComp(competencias, index) {
      return competencias[index - 1]
        ? Math.round(competencias[index - 1].NIVEL_LOGRO_COMPETENCIA)
        : null;
    },
    /*___________________________________________________________________
        │   * Método contabilizar las notas de cada competencia por tipo     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    conteoTipoNotasComp(valorArray, caso) {
      switch (caso) {
        case "AD+A":
          return valorArray.filter((e) =>
            [3, 4].includes(Math.round(e.NIVEL_LOGRO_COMPETENCIA))
          ).length;

        case "B":
          return valorArray.filter((e) =>
            [2].includes(Math.round(e.NIVEL_LOGRO_COMPETENCIA))
          ).length;

        case "C":
          return valorArray.filter((e) =>
            [1].includes(Math.round(e.NIVEL_LOGRO_COMPETENCIA))
          ).length;

        default:
          return 0;
      }
    },
    /*_____________________________________
        │   * Paso 1  ::: Crea año lectivo     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async crearAnioLectivoMultiStep() {
      try {
        this.step = "2";
        this.anoLectivoMultiStep.id_usurio = this.datoLogin.id;
        this.anoLectivoMultiStep.flag_cierre = 1;
        this.anoLectivoMultiStep.id_colegio = this.datoLogin.id_colegio;

        this.setEnviarMens({
          tipo: "S",
          mensaje: "Paso 1 realizado de manera éxitosa!",
        });
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: "Error al crear el año lectivo.",
        });
      }
    },

    /*_________________________________________________
        │   * Paso 2  ::: Crea los periodos siguientes     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async addPeriodosFuture() {
      if (this.$refs.formDatosPeriodo.validate()) {
        this.bloquearBotonGurdar = true;

        try {
          this.anoLectivoMultiStep.periodos.push(this.periodosMultiStep);

          this.setEnviarMens({
            tipo: "S",
            mensaje: "¡Paso 2 realizado de manera éxitosa!",
            tiempo: null,
          });

          this.bloquearBotonGurdar = false;

          this.Limpiar("periodo-guardar");
        } catch (error) {
          this.bloquearBotonGurdar = false;
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },
    /*_________________________________________________________
        │   * Paso 2  ::: Obtener los niveles dentro del paso 2    │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async getAllNivelesAdmin() {
      this.nivelParams = {
        id_ano_lectivo: parseInt(sessionStorage.getItem("id_ano_lectivo")),
        id_colegio_adm_nivel: parseInt(sessionStorage.getItem("id_colegio")),
      };

      try {
        let response = await axios.post(
          "/administrativo/nivel/niveladmin/",
          this.nivelParams
        );

        this.Niveles = response.data;
      } catch (error) {
        console.log("error here ", error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /*_______________________________________________________
        │   * Paso 3  ::: Elminar los periodos en el paso 3     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    elimnarPeriodo(item) {
      this.anoLectivoMultiStep.periodos = this.removeItem(
        this.anoLectivoMultiStep.periodos,
        item
      );
    },
    /*_______________________________________________________
        │   * Paso 3  ::: Elminar los periodos en el paso 3     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    removeItem(array, item) {
      return array.filter((element) => {
        return !Object.keys(item).every((key) => item[key] === element[key]);
      });
    },
    /*________________________________________________________
        │   * Paso 4  ::: Obtener los años lectivos actuales     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async getAllAnoLectivosActivos() {
      try {
        let response = await axios.get(
          "/administrativo/anoLectivo/estado/" + this.datoLogin.id_colegio + ""
        );

        if (response.data.length > 0) {
          this.dateMinGlobal = response.data[0].fecha_inicio;
          this.mindatePeriodo = response.data[0].fecha_inicio;
        }

        if (response.data.length > 0) {
          this.maxdatePeriodo = response.data[0].fecha_cierre;
        }

        this.getAllNivelesAdmin();
        this.anos_activos = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /*________________________________________________
        │   * Método para ejecutar el cierre del año     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    // eslint-disable-next-line no-unused-vars
    async cierreFinal(id_ano_lectivo_replicar, reconfirmacion) {
      try {
        let data = {
          ano_periodos: this.anoLectivoMultiStep,
          id_ano_lectivo_replicar,
          id_ano_lectivo_actual: parseInt(
            sessionStorage.getItem("id_ano_lectivo")
          ),
          reconfirmacion: reconfirmacion,
        };


        console.log({ data });


        // const response = respuesta;
        const response = await axios.post(
          "/cierreanio/cierreanioituacionestudiante/cierreFinalEstudiante",
          data
        );


        console.log({ response });


        if (response.data.MSG) {
          if (reconfirmacion) {
            this.logout();
          } else {
            this.dataAlumnos = response.data.DATOS;
            this.dataAlumnosOriginal = response.data.DATOS;
            this.gradosButtons = response.data.DATOS.filter(
              (item, index, array) =>
                index ===
                array.findIndex((t) => t.id_grado_adm === item.id_grado_adm)
            );
            this.openResult = true;
          }
        } else {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `Algo salió mal, revisa la configuracion previa`,
            tiempo: 3000,
          });
        }
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error al realizar el cierre final del estudiante`,
          tiempo: 5000,
        });
      }
    },
    /*____________________________________
        │   * Método para limpiar campos     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    Limpiar(tipo) {
      switch (tipo) {
        case "todo": {
          this.anoLectivoMultiStep = {
            nom_anolectivo: "",
            fecha_inicio: null,
            fecha_cierre: null,
            periodos: [],
          };
          break;
        }
        case "periodo-guardar": {
          this.periodosMultiStep = {
            nombre_periodo: "",
            fecha_inicio: null,
            fecha_cierre: null,
          };
          break;
        }
        case "cerrar-modal": {
          this.step = 1;
          this.anoLectivoMultiStep = {
            nom_anolectivo: "",
            fecha_inicio: null,
            fecha_cierre: null,
            periodos: [],
          };
          break;
        }
        default: {
          this.setEnviarMens({
            tipo: "W",
            mensaje: "No entro en ninguna condicional",
          });
          break;
        }
      }
    },
    /*_____________________________________
        │   * Método para formatear fecha     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    /*__________________________________
        │   * Método para cerrar modal     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    CerrarModal() {
      this.$emit("close");
      this.Limpiar("cerrar-modal");
    },
    /*_________________________________________________
        │   * Método para setear valores para testeos     │ 
         ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    setValues() {
      this.anoLectivoMultiStep = {
        nom_anolectivo: "Año 2025 nuevo",
        fecha_inicio: "2025-02-10",
        fecha_cierre: "2025-12-10",
        periodos: [
          {
            nombre_periodo: "P1",
            fecha_inicio: "2025-02-10",
            fecha_cierre: "2025-04-10",
            niveles_array: [
              {
                id: 268,
                id_colegio_adm_nivel: 277,
                id_nivel_adm_nivel: 326,
                id_ano_lectivo: 136,
                estado_nivel: 1,
                id_niveles: 326,
                id_nivel: 326,
                id_colegio_niveles: 277,
                desc_nivel: "Inicial",
                estado: 1,
                color: "#97B5C3",
                id_nivel_adm: 268,
                id_nivel_mant: 326,
                id_nivel_clickone: 4,
              },
              {
                id: 267,
                id_colegio_adm_nivel: 277,
                id_nivel_adm_nivel: 327,
                id_ano_lectivo: 136,
                estado_nivel: 1,
                id_niveles: 327,
                id_nivel: 327,
                id_colegio_niveles: 277,
                desc_nivel: "Primaria",
                estado: 1,
                color: "#79CA65",
                id_nivel_adm: 267,
                id_nivel_mant: 327,
                id_nivel_clickone: 5,
              },
              {
                id: 266,
                id_colegio_adm_nivel: 277,
                id_nivel_adm_nivel: 328,
                id_ano_lectivo: 136,
                estado_nivel: 1,
                id_niveles: 328,
                id_nivel: 328,
                id_colegio_niveles: 277,
                desc_nivel: "Secundaria",
                estado: 1,
                color: "#FD7E73",
                id_nivel_adm: 266,
                id_nivel_mant: 328,
                id_nivel_clickone: 6,
              },
            ],
          },
          {
            nombre_periodo: "P2",
            fecha_inicio: "2025-06-11",
            fecha_cierre: "2025-09-10",
            niveles_array: [
              {
                id: 268,
                id_colegio_adm_nivel: 277,
                id_nivel_adm_nivel: 326,
                id_ano_lectivo: 136,
                estado_nivel: 1,
                id_niveles: 326,
                id_nivel: 326,
                id_colegio_niveles: 277,
                desc_nivel: "Inicial",
                estado: 1,
                color: "#97B5C3",
                id_nivel_adm: 268,
                id_nivel_mant: 326,
                id_nivel_clickone: 4,
              },
              {
                id: 267,
                id_colegio_adm_nivel: 277,
                id_nivel_adm_nivel: 327,
                id_ano_lectivo: 136,
                estado_nivel: 1,
                id_niveles: 327,
                id_nivel: 327,
                id_colegio_niveles: 277,
                desc_nivel: "Primaria",
                estado: 1,
                color: "#79CA65",
                id_nivel_adm: 267,
                id_nivel_mant: 327,
                id_nivel_clickone: 5,
              },
              {
                id: 266,
                id_colegio_adm_nivel: 277,
                id_nivel_adm_nivel: 328,
                id_ano_lectivo: 136,
                estado_nivel: 1,
                id_niveles: 328,
                id_nivel: 328,
                id_colegio_niveles: 277,
                desc_nivel: "Secundaria",
                estado: 1,
                color: "#FD7E73",
                id_nivel_adm: 266,
                id_nivel_mant: 328,
                id_nivel_clickone: 6,
              },
            ],
          },
          {
            nombre_periodo: "P3",
            fecha_inicio: "2025-09-11",
            fecha_cierre: "2025-12-10",
            niveles_array: [
              {
                id: 268,
                id_colegio_adm_nivel: 277,
                id_nivel_adm_nivel: 326,
                id_ano_lectivo: 136,
                estado_nivel: 1,
                id_niveles: 326,
                id_nivel: 326,
                id_colegio_niveles: 277,
                desc_nivel: "Inicial",
                estado: 1,
                color: "#97B5C3",
                id_nivel_adm: 268,
                id_nivel_mant: 326,
                id_nivel_clickone: 4,
              },
              {
                id: 267,
                id_colegio_adm_nivel: 277,
                id_nivel_adm_nivel: 327,
                id_ano_lectivo: 136,
                estado_nivel: 1,
                id_niveles: 327,
                id_nivel: 327,
                id_colegio_niveles: 277,
                desc_nivel: "Primaria",
                estado: 1,
                color: "#79CA65",
                id_nivel_adm: 267,
                id_nivel_mant: 327,
                id_nivel_clickone: 5,
              },
              {
                id: 266,
                id_colegio_adm_nivel: 277,
                id_nivel_adm_nivel: 328,
                id_ano_lectivo: 136,
                estado_nivel: 1,
                id_niveles: 328,
                id_nivel: 328,
                id_colegio_niveles: 277,
                desc_nivel: "Secundaria",
                estado: 1,
                color: "#FD7E73",
                id_nivel_adm: 266,
                id_nivel_mant: 328,
                id_nivel_clickone: 6,
              },
            ],
          },
          {
            nombre_periodo: "P4",
            fecha_inicio: "2025-10-13",
            fecha_cierre: "2025-12-10",
            niveles_array: [
              {
                id: 268,
                id_colegio_adm_nivel: 277,
                id_nivel_adm_nivel: 326,
                id_ano_lectivo: 136,
                estado_nivel: 1,
                id_niveles: 326,
                id_nivel: 326,
                id_colegio_niveles: 277,
                desc_nivel: "Inicial",
                estado: 1,
                color: "#97B5C3",
                id_nivel_adm: 268,
                id_nivel_mant: 326,
                id_nivel_clickone: 4,
              },
              {
                id: 267,
                id_colegio_adm_nivel: 277,
                id_nivel_adm_nivel: 327,
                id_ano_lectivo: 136,
                estado_nivel: 1,
                id_niveles: 327,
                id_nivel: 327,
                id_colegio_niveles: 277,
                desc_nivel: "Primaria",
                estado: 1,
                color: "#79CA65",
                id_nivel_adm: 267,
                id_nivel_mant: 327,
                id_nivel_clickone: 5,
              },
              {
                id: 266,
                id_colegio_adm_nivel: 277,
                id_nivel_adm_nivel: 328,
                id_ano_lectivo: 136,
                estado_nivel: 1,
                id_niveles: 328,
                id_nivel: 328,
                id_colegio_niveles: 277,
                desc_nivel: "Secundaria",
                estado: 1,
                color: "#FD7E73",
                id_nivel_adm: 266,
                id_nivel_mant: 328,
                id_nivel_clickone: 6,
              },
            ],
          },
        ],
        id_usuario: 6860,
        flag_cierre: 1,
        id_colegio: 277,
      };
    },

    ShowDetalleAlumnoGrados(data) {
      this.showDetalle = true;
      this.panelAlumnosNotas = [];
      this.dataAlumnos = this.dataAlumnosOriginal.filter(
        (el) => el.id_grado_adm == data.id_grado_adm
      );
    },
  },
};
</script>
<style scoped>
thead th,
tbody td {
  border: thin solid rgba(0, 0, 0, 0.12);
}

.text-center {
  text-align: center;
}

.customheight {
  line-height: 35px;
}

.customrow {
  display: flex;
  align-items: center;
}
</style>
<style>
.expaco>.v-expansion-panel-content__wrap {
  padding: 0px 0px 10px 0px;
}
</style>